// Shared OK/Fehler/Warnung badge colors for the Rauchwarnmelder feature — the exact hex values
// the PDF protocol already uses (SmokeDetectorProtocolTemplate.jsx's ResultBadges), which the
// product owner found more readable than Mantine's own green/red/yellow theme shades. Kept here
// so the web app's badges and the PDF's SVG-image badges stay visually identical without
// duplicating the hex literals in every component.
export const SMOKE_DETECTOR_BADGE_COLORS = {
  ok: { color: '#2B8A3E', background: '#D3F9D8' },
  error: { color: '#C92A2A', background: '#FFE3E3' },
  warning: { color: '#8C6600', background: '#FFF3BF' },
  neutral: { color: '#495057', background: '#F1F3F5' },
};
